import de from './langs/de';
import es from './langs/es';
import fr from './langs/fr';
import it from './langs/it';
import jp from './langs/jp';
import kr from './langs/kr';
import us from './langs/us';
import br from './langs/br';
import mx from './langs/mx';
import ph from './langs/ph';
import nl from './langs/nl';
export const getTextToLang = (text1: string, key: string, val: string | number) => {
    return text1.replace(`${key}`, `${val}`);
};
export const langText: any = {
    us: us,
    de: de,
    fr: fr,
    it: it,
    es: es,
    jp: jp,
    kr: kr,
    br: br,
    mx: mx,
    ph: ph,
    nl: nl,
};
